import { render, staticRenderFns } from "./lecturerManage.vue?vue&type=template&id=83ef1e2c&"
import script from "./lecturerManage.vue?vue&type=script&lang=js&"
export * from "./lecturerManage.vue?vue&type=script&lang=js&"
import style0 from "./lecturerManage.vue?vue&type=style&index=0&id=83ef1e2c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports